import { type ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import FormControlButtonsBase from 'components/FormControlButtons/FormControlButtons';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import FacebookConfigCard from './FacebookConfigCard';
import GoogleConfigCard from './GoogleConfigCard';
import AppleWebConfigCard from './AppleWebConfigCard';
import AppleNativeConfigCard from './AppleNativeConfigCard';
import OtherLoginSettingsCard, {
  type OtherSettingsConfig,
} from './OtherLoginSettingsCard';
import { type AuthServicesConfig } from './types';

const FormControlButtons = FormControlButtonsBase as unknown as ComponentType<{
  [key: string]: unknown;
}>;

type AuthServicesModuleProps = {
  module: AuthServicesConfig | null;
  classes: { [key: string]: string };
  handleSubmit: () => void;
  handleModuleUpdate: (data: AuthServicesConfig | OtherSettingsConfig) => void;
  otherSettingsModule: OtherSettingsConfig | null;
};

const AuthServicesModule = ({
  module,
  classes,
  handleSubmit,
  handleModuleUpdate,
  otherSettingsModule,
}: AuthServicesModuleProps) => {
  const { t } = useTranslation();

  if (!module || !otherSettingsModule) {
    return (
      <div>
        {t('brands.newBrandForm.moduleNotLoaded', {
          defaultValue: '{{moduleName}} not loaded.',
          replace: 'AuthServicesModule',
        })}
      </div>
    );
  }

  return (
    <>
      <FacebookConfigCard
        config={module.facebook}
        classes={classes}
        onChange={facebook => handleModuleUpdate({ ...module, facebook })}
      />

      <GoogleConfigCard
        config={module.google}
        classes={classes}
        onChange={google => handleModuleUpdate({ ...module, google })}
      />

      <GridContainer>
        <GridItem xs={12} sm={6}>
          <AppleWebConfigCard
            config={module.apple}
            label={t('brands.newBrandForm.viaApple')}
            classes={classes}
            onChange={apple => handleModuleUpdate({ ...module, apple })}
          />
        </GridItem>
        <GridItem xs={12} sm={6}>
          <AppleNativeConfigCard
            config={module.appleNative}
            label={t('brands.newBrandForm.viaAppleNative')}
            classes={classes}
            onChange={appleNative =>
              handleModuleUpdate({ ...module, appleNative })
            }
          />
        </GridItem>
      </GridContainer>

      <OtherLoginSettingsCard
        config={otherSettingsModule}
        onChange={handleModuleUpdate}
      />

      <FormControlButtons
        classes={classes}
        submitText={t('common.shared.save', 'Zapisz')}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default AuthServicesModule;
